import React, {useEffect} from 'react';
import {auth} from '../../services';

export default ({redirect}) => {
    useEffect(async () => {
        await auth.logout(redirect);
    }, []);
    return null;
};
